import Service, { type Registry as Services, service } from '@ember/service';
import { task } from 'ember-concurrency';
import type { ComparisonSetWithoutOwn } from 'frontend-utils/utils/constants/benchmark-insight';
import type { BeniHotel } from 'lumen/models';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

// Fetches hotel-level BENI data (available comparison sets) from
// GET /api/v3/benchmarkinsight/hotels/:subscription_id.
// The fetch is triggered by the route's modelTask and must complete before
// comparison-set-dependent UI (dropdowns, integration cards) can render.
export default class BenchmarkInsightBeniHotelsService extends Service {
  @service declare errorTracking: Services['error-tracking'];
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;
  @service declare store: Services['store'];

  fetchTask = task(async () => {
    try {
      return await this.store.queryRecord<BeniHotel>(
        'benchmark-insight/hotel',
        {
          subscription_id: this.hotelAndMarketService.hotel.id,
        },
      );
    } catch (error) {
      this.errorTracking.captureException(error);
      return null;
    }
  });

  get availableComparisonSets(): ComparisonSetWithoutOwn[] {
    return this.fetchTask.last?.value?.availableComparisonSets ?? [];
  }

  get isLoading(): boolean {
    return this.fetchTask.isRunning;
  }
}

declare module '@ember/service' {
  interface Registry {
    'benchmark-insight/beni-hotels': BenchmarkInsightBeniHotelsService;
  }
}
